import React, { useState } from "react";
import { Col, Row, Card, OverlayTrigger } from "react-bootstrap";
import SplitNumber from "../../../components/SplitNumber";
import { useLocation, Link } from "react-router-dom";
// import LazyLoad from "react-lazyload";
import { isMobile } from "react-device-detect";
// import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import SmallImage from "./SmallImage";
import _ from "lodash";
import { IconChevronLeft } from "../../../../assets/icons";
function OrderItemShow({ item, key }) {
  let location = useLocation();

  //
  return (
    <Col xs={12} lg={4} key={key} className="pt-1 mt-1 tab-border-bottom">
      <Link
        className="text-dark"
        to={{
          pathname: "/order/orderDetail/" + item.id,
          state: {
            statusList: location?.state?.statusList,
            title: location?.state?.title,
            basketId: item.id,
          },
        }}
      >
        <Row className="px-1">
          <Card className="w-100 rounded-4">
            <Card.Body className="px-1">
              <Row>
                <Col xs={7}>
                  <div>{"کد سفارش " + item.id} </div>
                  <div className="fs-09 pt-1 text-black-06">
                    {item.lastModified}
                  </div>
                  <div className="fs-09 pt-1 text-black-06">
                    {" وضعیت : " + item.statusS}
                  </div>
                </Col>
                <Col xs={5} className="text-end text-danger">
                  <span className="fw-bold">
                    <SplitNumber number={item.price}></SplitNumber>
                  </span>
                  <span className="fs-075"> تومان</span>
                </Col>
              </Row>
              <div className="pr-2 arrow-left">
                <div className="bg-light-gray text-center rounded-4 border ps-2 pe-1 fs-085 small-svg-1">
                  مشاهده
                  <IconChevronLeft fillColor="dark" />
                  {/* مشاهده <ChevronLeft size={10} className="" /> */}
                </div>
              </div>
              <div className="pt-3 mt-2 border-dashed-top">
                <Row>
                  {!_.isEmpty(item.basketItemTemps) &&
                  item.basketItemTemps.length > 0 ? (
                    <>
                      {item.basketItemTemps?.map((basketItem, index2) => (
                        <Col key={index2} className=" m-0 p-0" xs="auto">
                          <SmallImage
                            basketItem={basketItem}
                            item={item}
                            index2={index2}
                          />
                        </Col>
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                </Row>
              </div>
            </Card.Body>
          </Card>
        </Row>
      </Link>
    </Col>
  );
}
export default OrderItemShow;
